<template>
    <sa-page-layout titolo="AnDIamo - Registra Erogazione" class="sa-no-space" btnRouterBackVisible>
        <template slot="table-body">
            <AndiamoErogazioneFormComponent ref="cmpAndiamoErogazioneFormComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AndiamoErogazioneFormComponent from "../components/AndiamoErogazioneFormComponent.vue";

export default {
    components: { SaPageLayout, AndiamoErogazioneFormComponent },
};
</script>

<style lang="scss" scoped></style>
